import { METRICS } from "../constants/data"
import { FormState, RuleBlock, Comparator, MetricKey } from "../types"
import { uid } from "./helpers"

const COMPARATORS: Comparator[] = [">", "<", "decreased", "increased"]

export function migrateState(raw: any): FormState {
  const state = (raw || {}) as any
  const scope = Array.isArray(state.scope)
    ? state.scope
    : state.scope
    ? [state.scope]
    : ["campaigns"]

  const defaultRule: RuleBlock = {
    id: uid(),
    name: "Условие 1",
    periodDays: 5,
    groups: [
      {
        id: uid(),
        logic: "OR",
        atoms: [
          {
            id: uid(),
            metric: "users_count",
            comparator: ">",
            value: 1000,
            periodDays: 5,
          },
        ],
      },
    ],
    actions: {
      budgetAction: "none",
      budgetAmount: 0,
      budgetUnit: "rub",
      sendTelegram: false,
      tgMessage: "",
      tgRecipients: [],
    },
  }

  const rules: RuleBlock[] = (state.rules || []).map((r: any, idx: number) => ({
    id: r.id || uid(),
    name: r.name || `Условие ${idx + 1}`,
    periodDays: Number(r.periodDays ?? state.lookbackDays ?? 5),
    groups: (r.groups || []).map((g: any) => ({
      id: g.id || uid(),
      logic: "OR",
      periodDays: Number(
        g.periodDays ?? r.periodDays ?? state.lookbackDays ?? 5
      ),
      atoms: (g.atoms || []).map((a: any) => {
        const metricKey = a.metric as MetricKey
        const metricDefault = (METRICS.find((m) => m.key === metricKey)
          ?.defaultComparator || ">") as Comparator
        const comp = COMPARATORS.includes(a.comparator as Comparator)
          ? (a.comparator as Comparator)
          : metricDefault
        return {
          id: a.id || uid(),
          metric: metricKey,
          comparator: comp,
          value:
            a.value === null || a.value === undefined || a.value === ""
              ? ""
              : Number(a.value),
          periodDays: Number(
            a.periodDays ??
              g.periodDays ??
              r.periodDays ??
              state.lookbackDays ??
              0
          ),
          periodDaysUntil: Number(a.periodDaysUntil ?? 0),
          unit: a.unit || "rub",
        }
      }),
    })),
    actions: r.actions
      ? {
          budgetAction: r.actions.budgetAction || "none",
          actionType: r.actions.actionType || "none",
          budgetAmount: Number(r.actions.budgetAmount ?? 0),
          budgetUnit: r.actions.budgetUnit || "rub",
          sendTelegram: Boolean(r.actions.sendTelegram),
          tgMessage: String(r.actions.tgMessage || ""),
          tgRecipients: Array.isArray(r.actions.tgRecipients)
            ? r.actions.tgRecipients
            : [],
        }
      : {
          budgetAction: "none",
          actionType: "none",
          budgetAmount: 0,
          budgetUnit: "rub",
          sendTelegram: false,
          tgMessage: "",
          tgRecipients: [],
        },
  }))

  // Validate adSource and set default if invalid
  const validAdSources = ["yandex_direct", "vk_ads"]
  const adSource = validAdSources.includes(state.adSource)
    ? state.adSource
    : "yandex_direct"

  return {
    adSource,
    accounts: Array.isArray(state.accounts) ? state.accounts : [],
    campaignIds: Array.isArray(state.campaignIds) ? state.campaignIds : [],
    adGroupIds: Array.isArray(state.adGroupIds) ? state.adGroupIds : [],
    adIds: Array.isArray(state.adIds) ? state.adIds : [],
    scope: scope.length ? [scope[0]] : ["campaigns"],
    lookbackDays: Number(state.lookbackDays ?? 5),
    checkEveryDays: Number(state.checkEveryDays ?? 5),
    rules: rules.length ? [rules[0]] : [defaultRule],
  }
}
